import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-qrcode',
	templateUrl:'./WaQRCodePage.html',
	styles: [],
	styleUrls:['./WaQRCodePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaQRCodePage
{
	mdContent_428 = `\`\`\`java
import com.jwebmp.webawesome.components.qrcode.WaQRCode;
\`\`\``;
	mdContent_429 = `\`\`\`java
var qr = new WaQRCode<>();
qr.setValue("https://jwebmp.com");
qr.setSize(200);
\`\`\``;
}
